import {h} from 'preact';
import {knownGraphQLErrors} from '../../../modules/core/GraphQLProvider/util';

export const GraphQLErrorDisplay = ( {error, render} ) => {
    if ( !render || !error || !error.graphQLErrors.length ) {
        return null;
    }

    const {graphQLErrors} = error;
    const errors = graphQLErrors.map( err => {
        const extensions = err.extensions || {code: 'UNKNOWN_ERROR'};
        const message = knownGraphQLErrors.includes( extensions.code )
            ? err.message
            : upi.conf.UNKNOWN_SUBMISSION_ERROR;

        return {
            message,
            ...extensions,
            locations: err.locations,
            path: err.path
        }
    } );

    return render( errors );
};
